import styled, { css } from "styled-components";
import ExternalLink from "ui/router/components/ExternalLink/ExternalLink";

export const TermsAndConditionsLink = styled(ExternalLink)(
    ({ theme }) => css`
        color: ${theme.palette.primary};
        &:hover {
            text-decoration: underline;
        }
    `,
);
